import "../../../styles/kjedeweb/singleChainProductListItem.scss";

import CheckBox from "../../common/components/CheckBox";
import FuturePriceItem from "./FuturePriceComponent.jsx";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../common/components/ResponsiveRows";
import SingleChainProductModal from "./SingleChainProductModal";
import moment from "moment";
import { toLocaleFixed } from "../../common/util/localization.jsx";

export class SingleChainSortimentListHeader extends React.PureComponent {
    render() {
        const {
            localization,
            multiSelect,
            showInvoiceGroup,
        } = this.props;

        return (
            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <div className="container">
                    {multiSelect && (
                        <div className="checkbox-column" />
                    )}
                    <div className="list">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn lg={4}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("chain", "chainSortiment", "productAndStatus")}
                                </div>
                            </ResponsiveColumn>                                                       
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("chain", "chainSortiment", "productStatus")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("chain", "chainSortiment", "noOfSalesUnits")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("chain", "chainSortiment", "netPrice")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("chain", "chainSortiment", "netPricePerUnit")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("chain", "chainSortiment", "adminChargePercent")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                    {localization.text("chain", "chainSortiment", "changed")}
                                </div>
                            </ResponsiveColumn>
                            {showInvoiceGroup && (
                                <ResponsiveColumn lg={1}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {localization.text("chain", "chainSortiment", "invoiceGroup")}
                                    </div>
                                </ResponsiveColumn>
                            )}
                        </ResponsiveRows>
                    </div>
                </div>
            </div>
        );
    }
}

SingleChainSortimentListHeader.propTypes = {
    localization: Localization.propTypes.isRequired,
    multiSelect: PropTypes.bool,
    showInvoiceGroup : PropTypes.bool,
};

export class SingleChainSortimentListItem extends React.PureComponent {
    constructor(props) {
        super(props);

        this.showProductModal = this.showProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
        this.onClickSelect = this.onClickSelect.bind(this);
    }

    onClickSelect(change) {
        this.props.editSelectedProduct({
            [this.props.product.productId]: change[this.props.product.productId] ? this.props.product : undefined,
        });
    }

    showProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        const {
            localization,
            product,
        } = this.props;

        const title = localization.text("chain", "productDetail");
        const saveButtonText = localization.text("chain", "save");
        this.props.setModal(<SingleChainProductModal localization={localization} product={product} onCloseModal={this.closeProductModal} width={1400} title={title} saveButtonText={saveButtonText} />);
    }

    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.setModal(null);
        this.props.clearChainProductDetails();
    }

    capitalizeFirstLetter(s) {
        s = s.toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    render() {
        const {
            product,
            selected,
            multiSelect,
        } = this.props;

        return (
            <div className="product-view-list-item-wrapper not-interactive" draggable={false}>
                <div className="container">
                    {multiSelect && (
                        <div className="checkbox-column">
                            <CheckBox property={product.productId} source={selected} label="" onChange={this.onClickSelect} />
                        </div>
                    )}
                    <div className="list">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={5} lg={4}>
                                <div className={"product-view-list-item"}>
                                    <div className={"product-view-list-item-image-background"} onClick={this.showProductModal}>
                                        {product.imageUrl && (
                                            <React.Fragment>
                                                <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div className="label16 product-view-list-item-prd-info_multiline" onClick={this.showProductModal}>
                                        <div>EPD {product.epdNo}</div>
                                        <div>{product.productName}</div>

                                        <div>
                                            <div style={{ float: "left" }} className="product-view-list-item-prd-info_catalogueInfo" >
                                                <div className={product.inCatalogue ? "circle-green" : "circle-red"}/>  {product.inCatalogue ? "Åpen" : "Stengt"}
                                            </div>
                                            {/* <div style={{ float: "left" }} className="product-view-list-item-prd-info_catalogueInfo" >
                                                {product.inCatalogue && (<div className="circle-blue"/>)}
                                                {product.inCatalogue ? "I varekatalog" : "Ikke i varekatalog"}
                                            </div>*/}                                        
                                        </div>
                                    </div>
                                </div>
                            </ResponsiveColumn>
                                                        
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item">
                                    <div style={{ width: "100%" }}>
                                        {product.status}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={2} lg={1}>
                                <div className="label14 product-view-list-item-price">
                                    <div style={{ width: "100%" }}>
                                        {product.noOfSalesUnits}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={2} lg={1}>
                                <div className="label14 product-view-list-item-price" >
                                    <div style={{ width: "100%" }}>
                                        {toLocaleFixed(product.currentNetPrice,2)}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={2} lg={1}>
                                <div className="label14 product-view-list-item-price">
                                    <div style={{ width: "100%" }}>
                                        {toLocaleFixed(product.currentNetPricePerSalesUnit,3)}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={2} lg={1}>
                                <FuturePriceItem
                                    currentValue={product.adminChargePercent}
                                    futureEndValue={product.futureAdminCharge}
                                    futureEndValueDate={product.futureAdminChargeDate}
                                />
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={0} lg={1}>
                                <div className="label14 product-view-list-item">
                                    <div style={{ width: "100%" }}>
                                        {product.lastChangedDate && moment(product.lastChangedDate).format("DD.MM.YY")}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            {product.showInvoiceGroup && (
                                <ResponsiveColumn xs={1} lg={1}>
                                    <div className="label14 product-view-list-item">
                                        <div style={{ width: "100%" }}>
                                            {this.capitalizeFirstLetter(product.invoiceGroupName)}
                                        </div>
                                    </div>
                                </ResponsiveColumn>
                            )}
                        </ResponsiveRows>
                    </div>
                </div>
            </div>
        );
    }
}

SingleChainSortimentListItem.propTypes = {
    clearChainProductDetails: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    product: PropTypes.object,
    setModal: PropTypes.func.isRequired,
    selected: PropTypes.object.isRequired,
    editSelectedProduct: PropTypes.func.isRequired,
    multiSelect: PropTypes.bool.isRequired,
};

SingleChainSortimentListItem.defaultProps = {
};